import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initSentry, installDeferredSentryIntegrations } from './config/sentry';
import { installStaleTabReloadHandler } from './utils/staleTabReload';
import { installAppCheckRecoveryHandler } from './utils/appCheckRecovery';
import { installSessionKeepAlive } from './utils/sessionKeepAlive';
import { registerServiceWorker } from './utils/swUpdate';

// Init Sentry before React mounts so any render-time crash reports.
initSentry();

// Register the service worker that precaches the app shell + chunks so
// the app loads/navigates offline, and surface a "new version → Refresh"
// prompt when a fresh build is ready. No-op in dev.
registerServiceWorker();

// Detect stale-tab-after-deploy chunk-load failures and prompt reload.
// Backstop only now — with the SW precaching chunks this should no
// longer fire offline (which was the false "new version" report).
installStaleTabReloadHandler();

// Detect App Check throttle (idle tab → expired token → 24h lockout)
// and prompt reload before the user sees broken pages.
installAppCheckRecoveryHandler();

// The proactive half: renew the session's tokens the moment the app comes
// back from a sleep / background stretch, before anything is tapped, and
// reload on the user's behalf if App Check locked itself out while idle.
installSessionKeepAlive();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Attach Sentry's Replay + Feedback integrations on idle, after the first
// render — keeps their setup cost off the boot path. No-op without a DSN.
installDeferredSentryIntegrations();
